module.exports = __webpack_public_path__ + "img/finish.d586a44b.png";